import get from 'lodash/get';
import * as companyIndexSectionNextActions from '../../action_creators/mic/company_index_section_next_action_creators';
import CompanyIndexSectionNextModel from '../../../models/mic/company_index_section_next_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(
      companyIndexSectionNextActions.companyIndexSectionNextLoading({}, store)
    );
    return CompanyIndexSectionNextModel.fetch(params, store)
      .then(function handleCompanyDetailData(CompanyData) {
        dispatch(
          companyIndexSectionNextActions.companyIndexSectionNextLoaded(
            CompanyData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in company actions, message: ${err.message}`);
        }

        dispatch(
          companyIndexSectionNextActions.companyIndexSectionNextLoadError(
            err,
            store
          )
        );
      });
  };
}
